import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import API_BASE from '../api';
import FOOTBALL_CLUBS from '../footballClubs';

const POSITIONS = ['שוער','בלם','מגן','קשר','כנף','חלוץ'];
// תפקידים שדורשים ציון צד במגרש
const SIDED_POSITIONS = ['מגן','כנף'];
const SIDES = ['ימין','שמאל','שני הצדדים'];
// צבעי חולצה — לפי סדר הספקטרום
const SHIRT_COLORS = [
  { name:'אדום',  hex:'#d63030' },
  { name:'כתום',  hex:'#e8842a' },
  { name:'צהוב',  hex:'#e8c832' },
  { name:'ירוק',  hex:'#2fa84f' },
  { name:'כחול',  hex:'#2b6fd6' },
  { name:'סגול',  hex:'#8a4fd0' },
];
const FEET = ['ימין','שמאל','שתי הרגליים'];
const PRODUCT_NAME = 'פתיח יוסטאר — פרופיל שחקן מקצועי';
const GIFT_LINE = 'ההצטרפות למועדון בחינם · הפתיח במתנה';
const WA_NUMBER = '9720546318704';

const WA_ICON = <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.123.554 4.118 1.528 5.847L.057 23.882l6.197-1.448A11.934 11.934 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.894a9.876 9.876 0 0 1-5.031-1.378l-.361-.214-3.741.981.998-3.648-.235-.374A9.867 9.867 0 0 1 2.106 12C2.106 6.535 6.535 2.106 12 2.106c5.466 0 9.894 4.429 9.894 9.894 0 5.466-4.428 9.894-9.894 9.894z"/></svg>;
const YT_ICON = <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.4.6A3 3 0 0 0 .5 6.2C0 8.1 0 12 0 12s0 3.9.5 5.8a3 3 0 0 0 2.1 2.1C4.5 20.5 12 20.5 12 20.5s7.5 0 9.4-.6a3 3 0 0 0 2.1-2.1C24 15.9 24 12 24 12s0-3.9-.5-5.8zM9.7 15.5V8.5l6.3 3.5-6.3 3.5z"/></svg>;
const PHONE_ICON = <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/></svg>;

// כפתור עוגן לטופס
function GiftButton({ style }) {
  return (
    <a href="#register" style={{
      display:'inline-flex', flexDirection:'column', alignItems:'center', gap:4,
      background:'linear-gradient(135deg,#d4af37,#f0cc60)', color:'#0a1120', fontWeight:900,
      fontSize:'clamp(1rem,3vw,1.15rem)', padding:'16px 32px', borderRadius:16,
      textDecoration:'none', boxShadow:'0 6px 32px rgba(212,175,55,0.55)',
      textAlign:'center', lineHeight:1.3, ...style,
    }}>
      <span>🎬 אני רוצה את פתיח יוסטאר במתנה</span>
      <span style={{fontSize:'clamp(0.78rem,2vw,0.88rem)', fontWeight:700, opacity:0.85, marginTop:2}}>{GIFT_LINE}</span>
    </a>
  );
}

// ── שדה חיפוש/השלמה אוטומטית של מועדון ──────────────────────
function TeamCombobox({ value, onChange }) {
  const [query, setQuery] = useState(value || '');
  const [open, setOpen]   = useState(false);
  const [active, setActive] = useState(0);
  const boxRef = useRef(null);

  useEffect(() => { setQuery(value || ''); }, [value]);
  useEffect(() => {
    const onDoc = e => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);

  const q = query.trim();
  const matches = q ? FOOTBALL_CLUBS.filter(c => c.includes(q)).slice(0, 8) : FOOTBALL_CLUBS.slice(0, 8);
  const options = [...matches, 'אחר (לא ברשימה)'];

  const pick = val => {
    const clean = val === 'אחר (לא ברשימה)' ? 'אחר' : val;
    onChange(clean); setQuery(clean); setOpen(false);
  };

  const onKey = e => {
    if (!open && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) { setOpen(true); return; }
    if (e.key === 'ArrowDown') { e.preventDefault(); setActive(a => Math.min(a + 1, options.length - 1)); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(a => Math.max(a - 1, 0)); }
    else if (e.key === 'Enter') { e.preventDefault(); if (open && options[active]) pick(options[active]); }
    else if (e.key === 'Escape') { setOpen(false); }
  };

  return (
    <div ref={boxRef} style={{ position:'relative' }}>
      <div style={{ position:'relative' }}>
        <span style={{ position:'absolute', right:12, top:'50%', transform:'translateY(-50%)', pointerEvents:'none', color:'#d4af37' }}>🔍</span>
        <input
          value={query}
          onChange={e => { setQuery(e.target.value); onChange(e.target.value); setOpen(true); setActive(0); }}
          onFocus={() => setOpen(true)}
          onKeyDown={onKey}
          placeholder="הקלידו שם מועדון — לדוגמה: פתח"
          autoComplete="off"
          style={{
            width:'100%', padding:'10px 40px 10px 14px', background:'#1a2a4a', color:'#fff',
            border:`1px solid ${open ? '#d4af37' : '#2a3a6a'}`, borderRadius:8, fontSize:'1rem',
            direction:'rtl', boxSizing:'border-box', fontFamily:"'Heebo', sans-serif",
          }}
        />
        {query && (
          <button type="button" onClick={() => { setQuery(''); onChange(''); setOpen(true); }}
            style={{ position:'absolute', left:10, top:'50%', transform:'translateY(-50%)', background:'none', border:'none', color:'#8a9aba', cursor:'pointer', fontSize:'1.1rem' }}>×</button>
        )}
      </div>
      {open && (
        <div style={{
          position:'absolute', top:'calc(100% + 4px)', right:0, left:0, zIndex:30,
          background:'#0d1a35', border:'1px solid #2a3a6a', borderRadius:10, overflow:'hidden',
          boxShadow:'0 12px 40px rgba(0,0,0,0.6)', maxHeight:280, overflowY:'auto',
        }}>
          {matches.length === 0 && q && (
            <div style={{ padding:'10px 14px', color:'#8a9aba', fontSize:'0.85rem' }}>לא נמצא מועדון בשם זה</div>
          )}
          {options.map((opt, i) => {
            const isOther = opt === 'אחר (לא ברשימה)';
            return (
              <div key={opt}
                onMouseDown={e => { e.preventDefault(); pick(opt); }}
                onMouseEnter={() => setActive(i)}
                style={{
                  padding:'10px 14px', cursor:'pointer', fontSize:'0.95rem',
                  color: isOther ? '#8a9aba' : '#fff',
                  background: active === i ? 'rgba(212,175,55,0.15)' : 'transparent',
                  borderTop: isOther ? '1px solid #1e2e5a' : 'none',
                  fontStyle: isOther ? 'italic' : 'normal',
                }}>
                {opt}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default function IntroForm() {
  const [form, setForm] = useState({
    child_first_name:'', child_last_name:'',
    child_dob_day:'', child_dob_month:'', child_dob_year:'',
    team:'', shirt_number:'', shirt_color:'', player_phone:'',
    parent_first_name:'', parent_last_name:'', parent_phone:'', parent_email:'',
  });
  const [positions, setPositions] = useState([]);
  const [sides, setSides] = useState({});          // { מגן:'ימין', כנף:'שני הצדדים' }
  const [isCaptain, setIsCaptain] = useState(false);
  const [strongFoot, setStrongFoot] = useState('');
  const [agreed, setAgreed]   = useState(false);
  const [error, setError]     = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone]       = useState(null);

  const handle = e => setForm({ ...form, [e.target.name]: e.target.value });

  const togglePosition = pos => {
    if (positions.includes(pos)) {
      setPositions(positions.filter(p => p !== pos));
      setSides(sd => { const next = { ...sd }; delete next[pos]; return next; });
    } else if (positions.length < 3) {
      setPositions([...positions, pos]);
    }
  };

  // תפקידים שנבחרו ודורשים ציון צד
  const sidedPicked = positions.filter(p => SIDED_POSITIONS.includes(p));

  const submit = async e => {
    e.preventDefault();
    if (!form.child_dob_year) { setError('יש למלא את שנת הלידה של השחקן/ית'); return; }
    if (!form.shirt_color) { setError('יש לבחור צבע חולצה'); return; }
    if (!strongFoot) { setError('יש לבחור את הרגל החזקה'); return; }
    const missingSide = sidedPicked.find(p => !sides[p]);
    if (missingSide) { setError(`יש לציין באיזה צד — ${missingSide}`); return; }
    if (!agreed) { setError('יש לאשר את תנאי ההצטרפות'); return; }
    setError(''); setLoading(true);
    try {
      // תפקידים כולל צד במגרש — "מגן ימין", "כנף שני הצדדים"
      const posText = positions.map(p => sides[p] ? `${p} ${sides[p]}` : p).join(', ');
      const notes = [
        posText || null,
        form.shirt_number ? `חולצה ${form.shirt_number}` : null,
        form.shirt_color ? `צבע ${form.shirt_color}` : null,
        strongFoot ? `רגל ${strongFoot}` : null,
        isCaptain ? 'קפטן' : null,
      ].filter(Boolean).join(' · ');
      const { data } = await axios.post(API_BASE + '/members', {
        first_name:  (form.parent_first_name + ' ' + form.parent_last_name).trim(),
        last_name:   form.parent_last_name,
        phone:       form.parent_phone,
        email:       form.parent_email || null,
        child_name:  (form.child_first_name + ' ' + form.child_last_name).trim(),
        child_last_name: form.child_last_name,
        child_dob:   form.child_dob_day && form.child_dob_month && form.child_dob_year
          ? `${form.child_dob_year}-${String(form.child_dob_month).padStart(2,'0')}-${String(form.child_dob_day).padStart(2,'0')}`
          : `${form.child_dob_year}-01-01`,
        team:        form.team,
        birth_year:  form.child_dob_year,
        positions:   notes || null,
        lead_source: 'intro',
        player_phone: form.player_phone || null,
        shirt_number: form.shirt_number || null,
        shirt_color:  form.shirt_color || null,
        strong_foot:  strongFoot || null,
        is_captain:   isCaptain,
      });
      setDone(data);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch(err) {
      setError(err.response?.data?.error || 'שגיאה, נסה שוב');
    } finally { setLoading(false); }
  };

  // ── מסך סיום ──────────────────────────────────────────────
  if (done) {
    const playerName = (form.child_first_name || '').trim();
    const waMsg = encodeURIComponent(
      `שלום יוסטאר! נרשמתי לפתיח יוסטאר — פרופיל שחקן מקצועי 🎬\nמצרף/ת תמונה שלי מהמגרש לפתיח 📸\nשם השחקן/ית: ${(form.child_first_name + ' ' + form.child_last_name).trim()}\nמועדון: ${form.team}\nשנתון: ${form.child_dob_year}`
    );
    return (
      <div style={{minHeight:'100vh', background:'linear-gradient(180deg,#060d1e 0%,#0a1a3e 100%)', padding:'40px 20px', direction:'rtl', fontFamily:"'Heebo', sans-serif"}}>
        <div style={{maxWidth:620, margin:'0 auto'}}>
          <div style={{textAlign:'center', marginBottom:32}}>
            <img src="/club-logo.png" alt="ליגת הכוכבים של יוסטאר"
              style={{width:'min(420px, 92%)', marginBottom:22, filter:'drop-shadow(0 4px 32px rgba(212,175,55,0.5))'}} />
            <div style={{fontSize:'2.2rem', marginBottom:10}}>🎬</div>
            <h1 style={{color:'#d4af37', fontWeight:900, fontSize:'clamp(1.4rem,4vw,1.9rem)', margin:'0 0 12px', lineHeight:1.35}}>
              {playerName ? `${playerName}, נרשמת!` : 'ההרשמה הושלמה!'}
            </h1>
            <p style={{color:'#c0cce6', fontSize:'1rem', lineHeight:1.8, margin:0}}>
              פתיח יוסטאר שלך בהכנה 🔥
            </p>
          </div>

          <div style={{background:'rgba(255,255,255,0.03)', border:'1px solid #1a2a4a', borderRadius:16, padding:24, marginBottom:24}}>
            <h2 style={{color:'#fff', fontWeight:800, fontSize:'1.05rem', margin:'0 0 14px'}}>⚡ מה קורה עכשיו</h2>
            {[
              { n:'1', t:'שולח לנו תמונה בוואטסאפ', d:'זה השלב שלך — שלח תמונה שלך מהמגרש לוואטסאפ של יוסטאר (הכפתור למטה). בלי תמונה אי אפשר להכין את הפתיח.' },
              { n:'2', t:'אנחנו מכינים את הפתיח', d:'פתיח יוסטאר — פרופיל שחקן מקצועי עם השם, המועדון, השנתון והחולצה שלך. עד 20 יום מרגע קבלת התמונה.' },
              { n:'3', t:'שולחים אותו בוואטסאפ', d:`הפתיח נשלח אליך${form.player_phone ? ` (${form.player_phone})` : ''} וגם להורה (${form.parent_phone}) — ויחד איתו הטבה מיוחדת מיוסטאר בשבילך 🎁` },
            ].map(s => (
              <div key={s.n} style={{display:'flex', gap:12, marginBottom:14, alignItems:'flex-start'}}>
                <div style={{flexShrink:0, width:26, height:26, borderRadius:'50%', background:'rgba(212,175,55,0.16)', border:'1px solid rgba(212,175,55,0.5)', color:'#d4af37', fontWeight:900, fontSize:'0.85rem', display:'flex', alignItems:'center', justifyContent:'center'}}>{s.n}</div>
                <div>
                  <div style={{color:'#d4af37', fontWeight:800, fontSize:'0.95rem'}}>{s.t}</div>
                  <div style={{color:'#b0bcd0', fontSize:'0.88rem', lineHeight:1.7, marginTop:2}}>{s.d}</div>
                </div>
              </div>
            ))}
          </div>

          <div style={{background:'linear-gradient(135deg,rgba(37,211,102,0.07),rgba(37,211,102,0.03))', border:'1px solid rgba(37,211,102,0.28)', borderRadius:16, padding:24, marginBottom:28, textAlign:'center'}}>
            <div style={{color:'#25d366', fontWeight:900, fontSize:'1.05rem', marginBottom:10}}>📸 שלב אחרון — שלח את התמונה שלך</div>
            <p style={{color:'#c0cce6', fontSize:'0.9rem', lineHeight:1.8, marginBottom:20}}>
              לחץ על הכפתור ושלח לוואטסאפ של יוסטאר תמונה שלך מהמגרש —
              <strong style={{color:'#fff'}}> משם אנחנו בונים את הפתיח.</strong>
              <br/><span style={{color:'#8a9aba', fontSize:'0.85rem'}}>ככל שהתמונה חדה ובאיכות גבוהה — הפתיח ייצא טוב יותר.</span>
            </p>
            <a href={`https://wa.me/${WA_NUMBER}?text=${waMsg}`} target="_blank" rel="noopener noreferrer" style={{
              display:'inline-flex', alignItems:'center', gap:10, background:'#25d366', borderRadius:30,
              padding:'13px 28px', color:'#fff', textDecoration:'none', fontWeight:800, fontSize:'1rem',
              boxShadow:'0 4px 20px rgba(37,211,102,0.4)',
            }}>
              {WA_ICON} שליחת התמונה לוואטסאפ של יוסטאר
            </a>
          </div>

          <div style={{textAlign:'center'}}>
            <a href="/" style={{color:'#5a7aa0', fontSize:'0.88rem', textDecoration:'none'}}>← לדף הבית של ליגת הכוכבים</a>
          </div>
        </div>
      </div>
    );
  }

  // ── דף הנחיתה + הטופס ─────────────────────────────────────
  return (
    <div>
      {/* ===== NAVBAR ===== */}
      <nav className="navbar" style={{justifyContent:'center'}}>
        <a href="/" style={{textDecoration:'none', display:'block', textAlign:'center'}}>
          <span style={{
            color:'#d4af37', fontWeight:700, fontSize:'clamp(0.8rem, 2.5vw, 1.1rem)',
            fontFamily:"'Heebo', sans-serif", whiteSpace:'nowrap', letterSpacing:'0.01em'
          }}>
            ⚽ ליגת הכוכבים של יוסטאר לשחקנים שחיים כדורגל
          </span>
        </a>
      </nav>

      {/* ===== HERO — קצר, כל מה שצריך במסך אחד ===== */}
      <div style={{marginTop:73, position:'relative', background:'#060d1e', lineHeight:0}}>
        <img src="/hero-player.jpg" alt="ליגת הכוכבים של יוסטאר — לשחקנים שחיים כדורגל"
          style={{width:'100%', display:'block', height:'clamp(330px, 34vw, 460px)',
            objectFit:'cover', objectPosition:'52% 40%'}} />
        <div style={{position:'absolute', inset:0, pointerEvents:'none',
          background:'linear-gradient(to bottom, rgba(6,13,30,0) 55%, rgba(6,13,30,0.92) 100%)'}} />
      </div>

      <div style={{background:'linear-gradient(180deg,#0a1530,#060d1e)', padding:'26px 20px 34px', direction:'rtl', textAlign:'center'}}>
        <h1 style={{color:'#fff', fontWeight:900, fontSize:'clamp(1.35rem,4.6vw,2.1rem)', margin:'0 0 6px', lineHeight:1.25}}>
          פתיח יוסטאר — פרופיל שחקן מקצועי
        </h1>
        <div style={{color:'#f0cc60', fontWeight:900, fontSize:'clamp(1.05rem,3.2vw,1.35rem)', marginBottom:16}}>במתנה 🎁</div>

        <img src="/ustarpro.png" alt="פתיח יוסטאר — פרופיל שחקן מקצועי"
          style={{width:'min(380px, 88%)', borderRadius:14, border:'1px solid rgba(212,175,55,0.35)',
            boxShadow:'0 10px 36px rgba(0,0,0,0.6)', margin:'0 auto 20px', display:'block'}} />

        {/* 3 שלבים — שורה אחת, בלי טקסט מיותר */}
        <div style={{display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:7, maxWidth:520, margin:'0 auto 22px'}}>
          {[
            {n:'1', icon:'📝', t:'ממלא פרטים'},
            {n:'2', icon:'📸', t:'שולח תמונה בוואטסאפ'},
            {n:'3', icon:'🎬', t:'מקבל את הפתיח'},
          ].map(x => (
            <div key={x.n} style={{background:'rgba(212,175,55,0.07)', border:'1px solid rgba(212,175,55,0.3)',
              borderRadius:12, padding:'10px 6px'}}>
              <div style={{fontSize:'1.25rem', lineHeight:1.2}}>{x.icon}</div>
              <div style={{color:'#f0cc60', fontWeight:800, fontSize:'clamp(0.72rem,2.6vw,0.85rem)', marginTop:4, lineHeight:1.35}}>{x.t}</div>
            </div>
          ))}
        </div>

        <GiftButton />
      </div>

      {/* ===== כוכבי יוסטאר — הוכחה מהירה, בלי טקסט ===== */}
      <div style={{background:'linear-gradient(180deg,#060d1e,#0a1a3e)', padding:'34px 20px 40px', direction:'rtl'}}>
        <div style={{maxWidth:880, margin:'0 auto'}}>
          <h2 style={{color:'#fff', fontWeight:900, fontSize:'clamp(1.1rem,3.2vw,1.5rem)', textAlign:'center', margin:'0 0 18px'}}>
            ⭐ צילמנו אותם כשהיו ילדים
          </h2>
          <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(180px,1fr))', gap:12}}>
            {[
              {name:'אוסקר גלוך', club:'אייאקס 🇳🇱', vid:'ML0BsC7WVdg'},
              {name:'אוריאן גורן', club:'ברצלונה 🇪🇸', vid:'gDDc5JHjbio'},
              {name:'מנור סולומון', club:'ווסטהאם 🏴󠁧󠁢󠁥󠁮󠁧󠁿', vid:'NnA-toEkRiQ'},
            ].map(({name, club, vid}) => (
              <a key={vid} href={`https://www.youtube.com/watch?v=${vid}`} target="_blank" rel="noopener noreferrer"
                style={{display:'block', borderRadius:12, overflow:'hidden', border:'1px solid #1e2e5a',
                  textDecoration:'none', background:'#0d1a35'}}>
                <div style={{position:'relative', paddingBottom:'56.25%', background:'#000'}}>
                  <img src={`https://img.youtube.com/vi/${vid}/hqdefault.jpg`} alt={name}
                    style={{position:'absolute', top:0, left:0, width:'100%', height:'100%', objectFit:'cover'}} />
                  <div style={{position:'absolute', top:'50%', left:'50%', transform:'translate(-50%,-50%)',
                    width:42, height:42, borderRadius:'50%', background:'rgba(212,175,55,0.9)',
                    display:'flex', alignItems:'center', justifyContent:'center'}}>
                    <svg viewBox="0 0 24 24" fill="#0a1120" width="20" height="20"><path d="M8 5v14l11-7z"/></svg>
                  </div>
                </div>
                <div style={{padding:'9px 12px', textAlign:'right'}}>
                  <div style={{color:'#fff', fontWeight:800, fontSize:'0.9rem'}}>{name}</div>
                  <div style={{color:'#d4af37', fontSize:'0.8rem', fontWeight:600}}>{club}</div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* ===== REGISTER FORM ===== */}
      <div className="form-section" id="register" style={{backgroundImage:"url('/stadium-dark.jpg')"}}>
        <div className="section-inner">
          <div className="form-box">
            <h2>⭐ הצטרפות לליגת הכוכבים</h2>
            <p className="subtitle" style={{color:'#d4af37', fontWeight:700, lineHeight:1.7, marginBottom:14}}>
              🎬 פתיח יוסטאר במתנה · דקה למלא
            </p>

            {/* מה זה ליגת הכוכבים — בקצרה */}
            <div style={{background:'rgba(212,175,55,0.07)', border:'1px solid rgba(212,175,55,0.3)', borderRadius:12, padding:'14px 16px', marginBottom:18}}>
              <div style={{color:'#f0cc60', fontWeight:900, fontSize:'0.95rem', marginBottom:8}}>⭐ מה זה ליגת הכוכבים?</div>
              <p style={{color:'#c0cce6', fontSize:'0.88rem', lineHeight:1.7, margin:'0 0 12px'}}>
                יוסטאר מצלמת משחקי כדורגל ומייצרת <strong style={{color:'#fff'}}>קליפי ביצועים אישיים</strong> לשחקנים צעירים —
                סרטון ערוך שמציג את היכולות שלך על המגרש. ליגת הכוכבים הוא הקהילה שלנו, וההצטרפות חינם.
              </p>
              <div style={{display:'flex', flexDirection:'column', gap:7}}>
                {[
                  {i:'🎥', t:'צילמנו את המשחק שלך? נעדכן אותך בוואטסאפ', d:'ותוכל להזמין קליפ ביצועים אישי מהמשחק'},
                  {i:'⭐', t:'עדכונים על מוצרי יוסטאר', d:'קליפ ביצועים, תמונות משחק ומחירי חבר מועדון'},
                  {i:'🎁', t:'מקבל: פתיח יוסטאר — פרופיל שחקן מקצועי', d:'זאת ההטבה שלך על ההצטרפות למועדון — במתנה'},
                ].map(x => (
                  <div key={x.t} style={{display:'flex', gap:9, alignItems:'flex-start'}}>
                    <span style={{fontSize:'1rem', lineHeight:1.4, flexShrink:0}}>{x.i}</span>
                    <div>
                      <div style={{color:'#fff', fontWeight:700, fontSize:'0.86rem', lineHeight:1.5}}>{x.t}</div>
                      <div style={{color:'#8a9aba', fontSize:'0.8rem', lineHeight:1.5}}>{x.d}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {error && <div className="alert alert-error">{error}</div>}

            <form onSubmit={submit}>

              {/* ── שלב 1: פרטי השחקן/ית ── */}
              <div className="form-step-label"><span className="step-num">1</span> הפרטים שלך</div>
              <div style={{color:'#8a9aba', fontSize:'0.83rem', marginTop:6, marginBottom:4}}>ככה זה יופיע בפתיח 👇</div>
              <div className="form-row">
                <div className="form-group">
                  <label>שם פרטי *</label>
                  <input name="child_first_name" value={form.child_first_name} onChange={handle} required placeholder="שם פרטי" />
                </div>
                <div className="form-group">
                  <label>שם משפחה *</label>
                  <input name="child_last_name" value={form.child_last_name} onChange={handle} required placeholder="שם משפחה" />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>תאריך לידה <span style={{color:'#8a9aba', fontWeight:400, fontSize:'0.82rem'}}>(שנה חובה)</span></label>
                  {/* RTL — שנה מימין, חודש באמצע, יום משמאל */}
                  <div style={{display:'grid', gridTemplateColumns:'1.5fr 1fr 1fr', gap:8}}>
                    <input name="child_dob_year" value={form.child_dob_year} onChange={handle} required placeholder="שנה *" type="number" min="2000" max="2020" style={{textAlign:'center'}} />
                    <input name="child_dob_month" value={form.child_dob_month} onChange={handle} placeholder="חודש" type="number" min="1" max="12" style={{textAlign:'center'}} />
                    <input name="child_dob_day" value={form.child_dob_day} onChange={handle} placeholder="יום" type="number" min="1" max="31" style={{textAlign:'center'}} />
                  </div>
                  
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>מועדון כדורגל *</label>
                  <TeamCombobox value={form.team} onChange={val => setForm(f => ({ ...f, team: val }))} />
                </div>
                <div className="form-group">
                  <label>מספר חולצה *</label>
                  <input name="shirt_number" value={form.shirt_number} onChange={handle} required type="number" min="1" max="99" placeholder="לדוגמה: 10" />
                </div>
              </div>

              {/* צבע חולצה */}
              <div className="form-group" style={{marginTop:8}}>
                <label style={{marginBottom:8, display:'block'}}>צבע החולצה *</label>
                <div style={{display:'flex', flexWrap:'wrap', gap:10}}>
                  {SHIRT_COLORS.map(c => {
                    const sel = form.shirt_color === c.name;
                    return (
                      <button key={c.name} type="button" onClick={()=>setForm(f=>({...f, shirt_color:c.name}))}
                        style={{
                          display:'inline-flex', alignItems:'center', gap:8, padding:'8px 16px', borderRadius:20,
                          border: sel ? '2px solid #d4af37' : '2px solid #2a3a6a',
                          background: sel ? 'rgba(212,175,55,0.16)' : '#1a2a4a',
                          color: sel ? '#f0cc60' : '#ccc', fontWeight: sel ? 800 : 500,
                          cursor:'pointer', fontSize:'0.95rem', fontFamily:"'Heebo', sans-serif", transition:'all 0.2s',
                        }}>
                        <span style={{width:16, height:16, borderRadius:'50%', background:c.hex, border:'1px solid rgba(255,255,255,0.35)', flexShrink:0}} />
                        {sel ? '✓ ' : ''}{c.name}
                      </button>
                    );
                  })}
                </div>
              </div>

              <div className="form-group" style={{marginTop:16}}>
                <label style={{marginBottom:8, display:'block'}}>תפקיד במגרש <span style={{color:'#8a9aba', fontWeight:400, fontSize:'0.85rem'}}>(עד 3)</span></label>
                <div style={{display:'flex', flexWrap:'wrap', gap:10}}>
                  {POSITIONS.map(pos => {
                    const selected = positions.includes(pos);
                    return (
                      <button key={pos} type="button" onClick={() => togglePosition(pos)}
                        style={{
                          padding:'8px 18px', borderRadius:20,
                          border: selected ? '2px solid #d4af37' : '2px solid #2a3a6a',
                          background: selected ? 'linear-gradient(135deg,#d4af37,#f0cc60)' : '#1a2a4a',
                          color: selected ? '#0a1120' : '#ccc',
                          fontWeight: selected ? 700 : 400,
                          cursor: positions.length >= 3 && !selected ? 'not-allowed' : 'pointer',
                          fontSize:'0.95rem', fontFamily:"'Heebo', sans-serif",
                          opacity: positions.length >= 3 && !selected ? 0.5 : 1, transition:'all 0.2s',
                        }}>
                        {selected ? '✓ ' : ''}{pos}
                      </button>
                    );
                  })}
                </div>

                {/* צד במגרש — למגן / כנף */}
                {sidedPicked.map(pos => (
                  <div key={pos} style={{marginTop:14, background:'rgba(122,176,255,0.06)', border:'1px solid rgba(122,176,255,0.28)', borderRadius:10, padding:'12px 14px'}}>
                    <div style={{color:'#7ab0ff', fontWeight:700, fontSize:'0.9rem', marginBottom:8}}>באיזה צד אתה משחק {pos}? *</div>
                    <div style={{display:'flex', flexWrap:'wrap', gap:8}}>
                      {SIDES.map(sd => {
                        const sel = sides[pos] === sd;
                        return (
                          <button key={sd} type="button" onClick={()=>setSides(x=>({...x, [pos]:sd}))}
                            style={{
                              padding:'7px 16px', borderRadius:18,
                              border: sel ? '2px solid #7ab0ff' : '2px solid #2a3a6a',
                              background: sel ? 'rgba(122,176,255,0.18)' : '#1a2a4a',
                              color: sel ? '#7ab0ff' : '#ccc', fontWeight: sel ? 800 : 400,
                              cursor:'pointer', fontSize:'0.9rem', fontFamily:"'Heebo', sans-serif",
                            }}>
                            {sel ? '✓ ' : ''}{sd}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                ))}
              </div>

              {/* רגל חזקה */}
              <div className="form-group" style={{marginTop:16}}>
                <label style={{marginBottom:8, display:'block'}}>הרגל החזקה *</label>
                <div style={{display:'flex', flexWrap:'wrap', gap:10}}>
                  {FEET.map(f => {
                    const sel = strongFoot === f;
                    return (
                      <button key={f} type="button" onClick={()=>setStrongFoot(f)}
                        style={{
                          padding:'8px 18px', borderRadius:20,
                          border: sel ? '2px solid #d4af37' : '2px solid #2a3a6a',
                          background: sel ? 'linear-gradient(135deg,#d4af37,#f0cc60)' : '#1a2a4a',
                          color: sel ? '#0a1120' : '#ccc', fontWeight: sel ? 700 : 400,
                          cursor:'pointer', fontSize:'0.95rem', fontFamily:"'Heebo', sans-serif",
                        }}>
                        {sel ? '✓ ' : ''}{f}
                      </button>
                    );
                  })}
                </div>
              </div>

              {/* קפטן */}
              <div className="form-group" style={{marginTop:16}}>
                <label style={{marginBottom:8, display:'block'}}>קפטן הקבוצה?</label>
                <div style={{display:'flex', gap:10}}>
                  {[{v:false, l:'לא'}, {v:true, l:'🎖️ כן, אני הקפטן'}].map(o => {
                    const sel = isCaptain === o.v;
                    return (
                      <button key={String(o.v)} type="button" onClick={()=>setIsCaptain(o.v)}
                        style={{
                          padding:'8px 18px', borderRadius:20,
                          border: sel ? '2px solid #d4af37' : '2px solid #2a3a6a',
                          background: sel ? 'linear-gradient(135deg,#d4af37,#f0cc60)' : '#1a2a4a',
                          color: sel ? '#0a1120' : '#ccc', fontWeight: sel ? 700 : 400,
                          cursor:'pointer', fontSize:'0.95rem', fontFamily:"'Heebo', sans-serif",
                        }}>
                        {o.l}
                      </button>
                    );
                  })}
                </div>
              </div>

              {/* וואטסאפ של השחקן */}
              <div className="form-group" style={{marginTop:16}}>
                <label>הוואטסאפ שלך</label>
                <input name="player_phone" value={form.player_phone} onChange={handle} type="tel" placeholder="05X-XXXXXXX (אם יש)" />
                
              </div>

              {/* ── שלב 2: פרטי קשר של ההורה ── */}
              <div className="form-step-label" style={{marginTop:24}}><span className="step-num">2</span> פרטי קשר של ההורה</div>
              <div style={{background:'rgba(212,175,55,0.07)', border:'1px solid rgba(212,175,55,0.3)', borderRadius:12, padding:'13px 15px', margin:'10px 0 14px'}}>
                <div style={{color:'#f0cc60', fontWeight:800, fontSize:'0.89rem', marginBottom:7}}>📲 רגע אחד — הפרטים של ההורה</div>
                <div style={{color:'#c0cce6', fontSize:'0.87rem', lineHeight:1.8}}>
                  את הפתיח אתה מקבל בוואטסאפ, <strong style={{color:'#fff'}}>וגם ההורה שלך מקבל אותו</strong> —
                  <span style={{color:'#d4af37', fontWeight:700}}> ויחד איתו הטבה מיוחדת מיוסטאר בשבילך 🎁</span>
                  <br/>לכן הפרטים של ההורה צריכים להיות נכונים — <strong style={{color:'#fff'}}>בלעדיהם אי אפשר להכין את הפתיח</strong> 👌
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>שם פרטי של ההורה *</label>
                  <input name="parent_first_name" value={form.parent_first_name} onChange={handle} required placeholder="ישראל" />
                </div>
                <div className="form-group">
                  <label>שם משפחה *</label>
                  <input name="parent_last_name" value={form.parent_last_name} onChange={handle} required placeholder="ישראלי" />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>וואטסאפ של ההורה *</label>
                  <input name="parent_phone" value={form.parent_phone} onChange={handle} required type="tel" placeholder="05X-XXXXXXX" />
                </div>
                <div className="form-group">
                  <label>אימייל</label>
                  <input name="parent_email" value={form.parent_email} onChange={handle} type="email" placeholder="example@email.com (לא חובה)" />
                </div>
              </div>

              {/* ── אישור ── */}
              <div className="checkbox-group" style={{marginTop:20}}>
                <label>
                  <input type="checkbox" checked={agreed} onChange={e=>setAgreed(e.target.checked)} />
                  <span>
                    ✅ אני וההורה שלי מאשרים הצטרפות למועדון וקבלת עדכונים בוואטסאפ
                    <br/><span style={{fontSize:'0.8rem', color:'#aab', marginTop:3, display:'block'}}>אפשר לבטל בכל רגע</span>
                  </span>
                </label>
              </div>

              <button className="btn btn-gold" type="submit" disabled={loading} style={{width:'100%', marginTop:24, fontSize:'1.1rem', lineHeight:1.5}}>
                {loading ? '...שולח' : (
                  <span style={{display:'flex', flexDirection:'column', alignItems:'center', gap:2}}>
                    <span>🎬 אני רוצה את פתיח יוסטאר במתנה</span>
                    <span style={{fontSize:'0.85rem', fontWeight:700, opacity:0.9, marginTop:2}}>{GIFT_LINE}</span>
                  </span>
                )}
              </button>

              <div style={{marginTop:14, color:'#8a9aba', fontSize:'0.84rem', textAlign:'center'}}>
                📸 בסוף — שולח תמונה שלך מהמגרש בוואטסאפ
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* ===== FOOTER — מינימלי ===== */}
      <footer style={{background:'#040a18', borderTop:'2px solid #1a2a4a', padding:'26px 20px 22px', direction:'rtl', textAlign:'center'}}>
        <div style={{color:'#d4af37', fontWeight:900, fontSize:'1rem', marginBottom:14}}>⭐ ליגת הכוכבים של יוסטאר</div>
        <div style={{display:'flex', flexWrap:'wrap', justifyContent:'center', gap:'10px 22px', marginBottom:16}}>
          <a href={`https://wa.me/${WA_NUMBER}`} target="_blank" rel="noopener noreferrer"
            style={{display:'flex', alignItems:'center', gap:7, color:'#25d366', textDecoration:'none', fontSize:'0.86rem', fontWeight:700}}>
            {WA_ICON} וואטסאפ
          </a>
          <a href="tel:0546318704" style={{display:'flex', alignItems:'center', gap:7, color:'#8a9aba', textDecoration:'none', fontSize:'0.86rem'}}>
            {PHONE_ICON} 054-6318704
          </a>
          <a href="https://www.youtube.com/@ustarsoccer2972" target="_blank" rel="noopener noreferrer"
            style={{display:'flex', alignItems:'center', gap:7, color:'#e00', textDecoration:'none', fontSize:'0.86rem'}}>
            {YT_ICON} יוטיוב
          </a>
        </div>
        <div style={{color:'#3a4a6a', fontSize:'0.78rem'}}>© {new Date().getFullYear()} יוסטאר</div>
      </footer>
    </div>
  );
}
